import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  FILTER_NAMES,
  CONSTANTS,
  DATE_FORMATS,
  VERTICALS,
  VERTICAL_OPTIONS,
  VERTICAL_OPTIONS_FOR_BLOGS_AND_FORUMS,
  languages,
  countries,
} from "../../../constants/app-constant";
import SocialFilterItem from "./SocialFilterItem";
import {
  SOCIAL_SOURCES_OPTIONS,
  DATA_COUNT_LIMIT,
  TONALITY_FILTER,
  SOCIAL_TONALITY_FILTER,
} from "../../../constants/static-filter";
import { CloseIcon } from "../../Icons/icons.component";
import DateRangeFilter from "./DateRangeFilter";
import SocialCountFilters from "./FilterGroups/SocialCountFilters";
import { Input } from "../../Shared/FormElements/Input";
export const dataCountLimits = [10, 20, 50, 100, 500, 1000];
const { EMPTY_OBJECT } = CONSTANTS;
const {
  ENTITY,
  CHANNELS,
  REACTIONS,
  TONALITY,
  COMMENTS,
  CITY,
  VERTICALS_FOR_BLOG_AND_FORUMS,
  TAGS,
} = FILTER_NAMES;

const SocialFilters = ({
  handleFilterSelect,
  fetchSocialFeeds,
  cityData,
  selectCity,
  setSelectedCity,
  fromDate,
  toDate,
  tonality,
  setTonality,
  comments,
  setComments,
  channelType,
  setChannelType,
  reaction,
  setReaction,
  setShowFilter,
  setSelectedTopics,
  selectedTopics,
  entityList,
  isBlogAndForum,
  setIsFavouriteChecked,
  setMainstreammediaChecked,
  isMainstreammedia,
  isFavouriteChecked,
  vertical,
  setVertical,
  countFilters,
  setCountFilters,
  isSocial,
  showInfluencerPosts,
  setShowInfluencerPosts,
  selectedTaglist,
  setSelectedTaglist,
  tagList,
  setHeadline,
  setKeyword,
  keyword,
  headline,
  language,
  country,
  setLanguage,
  setCountry,
}) => {
  const [bufferDateStart, setBufferDateStart] = useState(fromDate);
  const [orderedLanguage, setorderedLanguage] = useState([]);
  const [bufferDateEnd, setBufferDateEnd] = useState(toDate);
  const [selectedFilter, setSelectedFilter] = useState(undefined);
  const [hasDateChanged, setHasDateChanged] = useState(false);

  const [countrylist, setcountrylist] = useState([]);

  useEffect(() => {
    setBufferDateEnd(toDate);
    setBufferDateStart(fromDate);
  }, [toDate, fromDate]);

  useEffect(() => {
    let tArr = []
    Object.entries(languages).forEach((e) => {
      if (Array.isArray(language) && language.length && language.includes(e[0]))
        tArr.unshift({
          label: e[1].name,
          value: e[0],
          id: e[0],
        });
      else
        tArr.push({
          label: e[1].name,
          value: e[0],
          id: e[0],
        });
    })
    setorderedLanguage(tArr)
  },[language,languages])

  useEffect(() => setHasDateChanged(true), [bufferDateEnd, bufferDateStart]);
  // TODO: Needed for filter date range. To be done later.
  // const selectedClient =
  //   useSelector(
  //     (state) => state.clientReducer && state.clientReducer.selectedClient
  //   ) || EMPTY_OBJECT;
  // const handleBufferDateChange = (date, type, from) => {
  //   const formattedDate = date;
  //   if (type === "start") {
  //     setBufferDateStart(formattedDate);
  //   } else {
  //     setBufferDateEnd(formattedDate);
  //   }
  // };

  const tempDateObj = {
    startDate: moment(bufferDateStart).format("yyyy/MM/DD"),
    endDate: moment(bufferDateEnd).format("yyyy/MM/DD"),
  };

  const handleApplyFilter = () => {
    fetchSocialFeeds(null);
    // setHasDateChanged(false);
    setShowFilter(false);
  };

  const handleResetAll = () => {
    window.location.reload();
  };

  const mainstreammedia = localStorage.getItem("mainstreammedia");

  return (
    <div className="filtersWrap socialFiltersWrap">
      <div className="filtersHeader d-flex">
        <h4>Filters</h4>
        <button onClick={() => setShowFilter(false)} className="closeIconWrap">
          <CloseIcon />
        </button>
      </div>
      <div className="filterReset">
        <button onClick={() => handleResetAll()} className="btn resetAllBtn">
          Reset All
        </button>
      </div>
      <div className="filtersColumnWrap">
        {/* TODO: Show when direct download feature is ready for social feeds.
         {!<DateRangeFilter
          isSocialMain
          handleDateChange={handleBufferDateChange}
          startRange={bufferDateStart}
          endRange={bufferDateEnd}
          key="social-feed"
          minDate={selectedClient ? selectedClient.start_date : null}
          maxDate={selectedClient ? selectedClient.end_date : null}
        />} */}
        <SocialFilterItem
          identity={ENTITY}
          options={entityList}
          filterKey={selectedTopics}
          filterSetter={setSelectedTopics}
          filterName={ENTITY}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          multiselect
          showNone={false}
        />
        {!isBlogAndForum && (
          <SocialFilterItem
            identity={CHANNELS}
            options={SOCIAL_SOURCES_OPTIONS}
            filterKey={channelType}
            filterSetter={setChannelType}
            filterName={CHANNELS}
            multiselect
            showNone={false}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />
        )}
        <SocialFilterItem
          identity={TAGS}
          options={tagList}
          filterKey={selectedTaglist}
          filterSetter={setSelectedTaglist}
          filterName={TAGS}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          multiselect
          showNone={false}
          isTags
        />
        {isBlogAndForum && (
          <SocialFilterItem
            identity={VERTICALS_FOR_BLOG_AND_FORUMS}
            options={VERTICAL_OPTIONS_FOR_BLOGS_AND_FORUMS}
            filterKey={vertical}
            filterSetter={setVertical}
            filterName={VERTICALS_FOR_BLOG_AND_FORUMS}
          />
        )}
        {isSocial && (
          <SocialCountFilters
            filters={countFilters}
            setFilters={setCountFilters}
            channelType={channelType}
          />
        )}

        {isSocial && (
          <SocialFilterItem
          multiselect
          identity={"Country"}          
          options={countries}
          filterKey={country}
          filterSetter={setCountry}
          filterName={"COUNTRY"}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
        )}
        
        <SocialFilterItem
          identity={TONALITY}
          options={SOCIAL_TONALITY_FILTER.values}
          filterKey={tonality}
          filterSetter={setTonality}
          filterName={TONALITY}
        />
        {isSocial && (
          <SocialFilterItem
            multiselect
            identity={"Language"}
            options={orderedLanguage}
            // options={Object.entries(languages).map((e) => ({
            //   label: e[1].name,
            //   value: e[0],
            // }))}
            filterKey={language}
            filterSetter={setLanguage}
            filterName={"LANGUAGE"}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          />
        )}
        {
          <>
            <div className="form-group">
              <div className="filterDiv filteInputText searchField">
                <Input
                  id="headline-filter"
                  type="text"
                  onChange={(value) => {
                    setHeadline(value);
                  }}
                  value={headline}
                  placeholder="Search by Headline"
                ></Input>
              </div>
            </div>
            {
              <div className="form-group">
                <div className="filterDiv filteInputText searchField">
                  <Input
                    id="keyword-filter"
                    type="text"
                    onChange={(value) => {
                      setKeyword(value);
                    }}
                    value={keyword}
                    placeholder="Search by Keywords"
                  ></Input>
                </div>
              </div>
            }
          </>
        }


        {isSocial && mainstreammedia != 0 && (
          <div className="form-group showFavourited">
            <label className="inputWrap">
              Posts by Mainstream Media
              <input
                type="checkbox"
                onChange={() => setMainstreammediaChecked(!isMainstreammedia)}
                checked={isMainstreammedia}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        )}

        <div className="form-group showFavourited">
          <label className="inputWrap">
            Show Favourited
            <input
              type="checkbox"
              onChange={() => setIsFavouriteChecked(!isFavouriteChecked)}
              checked={isFavouriteChecked}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        {isSocial && (
          <div className="form-group showFavourited">
            <label className="inputWrap">
              Posts by Influencers
              <input
                type="checkbox"
                onChange={() => setShowInfluencerPosts(!showInfluencerPosts)}
                checked={showInfluencerPosts}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        )}
        <div className="form-group form-action text-right">
          <button className="btn btnBlue" onClick={handleApplyFilter}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialFilters;
